(() => {
  const WRAP_VARIANT_ID = 58877925425526;
  const NOTE_VARIANT_ID = 58877925818742;
  const SERVICE_VARIANT_IDS = new Set([WRAP_VARIANT_ID, NOTE_VARIANT_ID]);
  const debounceTimers = new WeakMap();
  let deliveryInterval = null;

  const drawer = () => document.querySelector('cart-drawer');

  const sectionIds = () => {
    const element = drawer();
    if (!element || typeof element.getSectionsToRender !== 'function') return 'cart-drawer';
    return element.getSectionsToRender().map((section) => section.id).join(',');
  };

  const request = async (endpoint, payload) => {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({...payload, sections: sectionIds(), sections_url: window.location.pathname})
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'No se pudo actualizar el carrito');
    return data;
  };

  const render = (data) => {
    const element = drawer();
    if (element && data.sections && typeof element.renderContents === 'function') element.renderContents(data);
    window.setTimeout(() => {
      initDeliveryTimer();
      loadCrossSell(true);
    }, 120);
  };

  const setBusy = (row, busy, message = '') => {
    row.classList.toggle('is-loading', busy);
    row.querySelectorAll('input, textarea').forEach((control) => { control.disabled = busy; });
    const status = row.querySelector('[data-lvc-gift-status]');
    if (status) status.textContent = message;
  };

  const propertiesFor = (row, type, noteText = '') => {
    const properties = {
      'Artículo': row.dataset.parentTitle || '',
      _lvc_parent_key: row.dataset.parentKey || '',
      _lvc_service: type
    };
    if (type === 'note') properties.Nota = noteText;
    return properties;
  };

  const addService = async (row, type) => {
    const variantId = type === 'wrap' ? WRAP_VARIANT_ID : NOTE_VARIANT_ID;
    const quantity = Math.max(1, Number.parseInt(row.dataset.parentQuantity || '1', 10));
    const noteText = type === 'note' ? (row.querySelector('[data-lvc-gift-note-text]')?.value || '').trim() : '';
    const data = await request(window.routes.cart_add_url + '.js', {
      items: [{id: variantId, quantity, properties: propertiesFor(row, type, noteText)}]
    });
    render(data);
  };

  const removeService = async (lineKey) => {
    if (!lineKey) return;
    const data = await request(window.routes.cart_change_url + '.js', {id: lineKey, quantity: 0});
    render(data);
  };

  const updateNote = async (row) => {
    const lineKey = row.dataset.noteLineKey;
    if (!lineKey) return;
    const quantity = Math.max(1, Number.parseInt(row.dataset.parentQuantity || '1', 10));
    const noteText = (row.querySelector('[data-lvc-gift-note-text]')?.value || '').trim();
    setBusy(row, true);
    try {
      const data = await request(window.routes.cart_change_url + '.js', {
        id: lineKey,
        quantity,
        properties: propertiesFor(row, 'note', noteText)
      });
      render(data);
    } catch (error) {
      setBusy(row, false, error.message);
    }
  };

  const cleanupOrphans = async () => {
    try {
      const response = await fetch(window.routes.cart_url + '.js', {headers: {Accept: 'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      const parents = new Map();
      cart.items.forEach((item) => {
        if (!SERVICE_VARIANT_IDS.has(item.variant_id)) parents.set(item.key, item.quantity);
      });
      const updates = {};
      cart.items.forEach((item) => {
        if (!SERVICE_VARIANT_IDS.has(item.variant_id)) return;
        const parentKey = item.properties?._lvc_parent_key;
        const parentQuantity = parentKey ? parents.get(parentKey) : null;
        if (!parentQuantity) updates[item.key] = 0;
        else if (item.quantity !== parentQuantity) updates[item.key] = parentQuantity;
      });
      if (!Object.keys(updates).length) return;
      const data = await request(window.routes.cart_update_url + '.js', {updates});
      render(data);
    } catch (error) {}
  };

  const initDeliveryTimer = () => {
    if (deliveryInterval) {
      window.clearInterval(deliveryInterval);
      deliveryInterval = null;
    }
    const root = document.getElementById('lvc-cart-express');
    if (!root) return;
    const zone = 'Europe/Madrid';
    const holidays = ['2026-10-12','2026-11-02','2026-12-07','2026-12-08','2026-12-25','2027-01-01','2027-01-06','2027-03-25','2027-03-26','2027-09-08','2027-10-11','2027-10-12','2027-11-01','2027-12-06','2027-12-08'];
    const locale = root.dataset.locale || 'es-ES';
    const pad = (n) => String(n).padStart(2,'0');
    const parts = (ms) => {
      const values = {};
      new Intl.DateTimeFormat('en-US',{timeZone:zone,hour12:false,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit'}).formatToParts(new Date(ms)).forEach((part) => { values[part.type] = part.value; });
      if (values.hour === '24') values.hour = '00';
      return values;
    };
    const offset = (ms) => {
      const p = parts(ms);
      return Date.UTC(+p.year,+p.month-1,+p.day,+p.hour,+p.minute,+p.second)-ms;
    };
    const instant = (y,m,d,h) => {
      let value = Date.UTC(y,m-1,d,h,0,0);
      for (let i=0;i<2;i+=1) value = Date.UTC(y,m-1,d,h,0,0)-offset(value);
      return value;
    };
    const key = (o) => o.y+'-'+pad(o.m)+'-'+pad(o.d);
    const dayOfWeek = (o) => new Date(Date.UTC(o.y,o.m-1,o.d)).getUTCDay();
    const isWorkday = (o) => {
      const day = dayOfWeek(o);
      return day > 0 && day < 6 && !holidays.includes(key(o));
    };
    const nextDay = (o) => {
      const date = new Date(Date.UTC(o.y,o.m-1,o.d));
      date.setUTCDate(date.getUTCDate()+1);
      return {y:date.getUTCFullYear(),m:date.getUTCMonth()+1,d:date.getUTCDate()};
    };
    const nextWorkday = (o) => {
      let candidate = nextDay(o);
      while (!isWorkday(candidate)) candidate = nextDay(candidate);
      return candidate;
    };
    const sameDate = (a,b) => a.y===b.y && a.m===b.m && a.d===b.d;
    const formatDelivery = (o) => {
      const date = new Date(Date.UTC(o.y,o.m-1,o.d));
      const weekday = new Intl.DateTimeFormat(locale,{weekday:'long',timeZone:'UTC'}).format(date);
      const dayMonth = new Intl.DateTimeFormat(locale,{day:'numeric',month:'long',timeZone:'UTC'}).format(date);
      return weekday+' '+dayMonth;
    };

    const setup = () => {
      const p = parts(Date.now());
      const today = {y:+p.year,m:+p.month,d:+p.day};
      const hour = +p.hour;
      const shipDay = isWorkday(today) && hour < 17 ? today : nextWorkday(today);
      const deliveryDay = nextWorkday(shipDay);
      const target = instant(shipDay.y,shipDay.m,shipDay.d,17);
      const tomorrow = nextDay(today);
      const prefix = root.dataset.questionPrefix || '';
      const lead = sameDate(deliveryDay,tomorrow) ? (root.dataset.tomorrow || '') : (root.dataset.on || '');
      const question = root.querySelector('#lvc-cart-edb-question');
      if (question) question.textContent = prefix+' '+lead+' '+formatDelivery(deliveryDay)+'?';
      root.style.display='block';

      const tick = () => {
        const total = Math.floor((target-Date.now())/1000);
        if (total <= 0) {
          initDeliveryTimer();
          return;
        }
        const days = Math.floor(total/86400);
        const remainder = total%86400;
        const daysBlock = root.querySelector('#lvc-cart-edb-days-block');
        const daysSep = root.querySelector('#lvc-cart-edb-days-sep');
        if (days) {
          root.querySelector('#lvc-cart-edb-days').textContent=days;
          daysBlock.hidden=false;
          daysSep.hidden=false;
        } else {
          daysBlock.hidden=true;
          daysSep.hidden=true;
        }
        root.querySelector('#lvc-cart-edb-hours').textContent=pad(Math.floor(remainder/3600));
        root.querySelector('#lvc-cart-edb-minutes').textContent=pad(Math.floor(remainder%3600/60));
        root.querySelector('#lvc-cart-edb-seconds').textContent=pad(remainder%60);
      };
      tick();
      deliveryInterval=window.setInterval(tick,1000);
    };
    setup();
  };

  const rotateCrossSellHeadline = (scope = drawer()) => {
    const headline = scope?.querySelector?.('[data-lvc-cross-headline]');
    if (!headline) return;
    const phrases = (headline.dataset.phrases || '')
      .split('||')
      .map((phrase) => phrase.trim())
      .filter(Boolean);
    if (!phrases.length) return;
    const storageKey = 'lvc_cross_sell_phrase_last';
    let last = -1;
    try { last = Number.parseInt(sessionStorage.getItem(storageKey) || '-1', 10); } catch (error) {}
    let index = Math.floor(Math.random() * phrases.length);
    if (phrases.length > 1 && index === last) index = (index + 1) % phrases.length;
    headline.textContent = phrases[index];
    try { sessionStorage.setItem(storageKey, String(index)); } catch (error) {}
  };

  const loadCrossSell = async (force=false) => {
    const slot = drawer()?.querySelector('[data-lvc-cart-cross-sell]');
    if (!slot) return;
    if (slot.querySelector('[data-lvc-cross-sell-result]')) {
      slot.dataset.loaded='true';
      rotateCrossSellHeadline(slot);
      return;
    }
    if (!force && slot.dataset.loaded === 'true') return;
    slot.dataset.loaded='loading';
    try {
      const response = await fetch(window.location.pathname+'?section_id=lvc-cart-cross-sell', {headers:{Accept:'text/html'}});
      if (!response.ok) throw new Error('Cross sell request failed');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html,'text/html');
      const rendered = doc.querySelector('[data-lvc-cross-sell-result]');
      if (!rendered) {
        slot.remove();
        return;
      }
      slot.replaceChildren(...rendered.childNodes);
      slot.dataset.loaded='true';
      rotateCrossSellHeadline(slot);
    } catch (error) {
      slot.remove();
    }
  };

  let enhancementTimer = null;
  const scheduleDrawerEnhancements = () => {
    if (enhancementTimer) window.clearTimeout(enhancementTimer);
    enhancementTimer = window.setTimeout(() => {
      initDeliveryTimer();
      const slot = drawer()?.querySelector('[data-lvc-cart-cross-sell]');
      if (slot?.querySelector('[data-lvc-cross-sell-result]')) {
        slot.dataset.loaded='true';
        rotateCrossSellHeadline(slot);
      }
    }, 60);
  };

  const observeDrawerEnhancements = () => {
    const element = drawer();
    if (!element || element.dataset.lvcEnhancementsObserved === 'true') return;
    element.dataset.lvcEnhancementsObserved = 'true';
    const observer = new MutationObserver((mutations) => {
      const relevant = mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) => {
        if (node.nodeType !== 1) return false;
        return node.matches?.('#CartDrawer, .drawer__inner, #lvc-cart-express, [data-lvc-cart-cross-sell]') ||
          node.querySelector?.('#lvc-cart-express, [data-lvc-cart-cross-sell]');
      }));
      if (relevant) scheduleDrawerEnhancements();
    });
    observer.observe(element, {childList:true, subtree:true});
    scheduleDrawerEnhancements();
  };

  document.addEventListener('change', async (event) => {
    const crossSelect = event.target.closest('[data-lvc-cross-select]');
    if (crossSelect) {
      const card = crossSelect.closest('[data-lvc-cross-card]');
      const option = crossSelect.selectedOptions[0];
      const addButton = card?.querySelector('[data-lvc-cross-add]');
      const price = card?.querySelector('[data-lvc-cross-price]');
      if (addButton) addButton.dataset.variantId = crossSelect.value;
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      return;
    }
    const toggle = event.target.closest('[data-lvc-gift-toggle]');
    if (toggle) {
      const row = toggle.closest('[data-lvc-gift-options]');
      if (!row) return;
      const type = toggle.dataset.lvcGiftToggle;
      const noteField = row.querySelector('[data-lvc-gift-note-field]');
      if (type === 'note' && noteField) noteField.hidden = !toggle.checked;
      setBusy(row, true);
      try {
        if (toggle.checked) await addService(row, type);
        else {
          const lineKey = type === 'wrap' ? row.dataset.wrapLineKey : row.dataset.noteLineKey;
          await removeService(lineKey);
        }
      } catch (error) {
        toggle.checked = !toggle.checked;
        if (type === 'note' && noteField) noteField.hidden = !toggle.checked;
        setBusy(row, false, error.message);
      }
      return;
    }
    if (event.target.closest('.quantity__input')) {
      window.setTimeout(() => {
        cleanupOrphans();
        initDeliveryTimer();
        loadCrossSell(true);
      },1200);
    }
  });

  document.addEventListener('input', (event) => {
    const textarea = event.target.closest('[data-lvc-gift-note-text]');
    if (!textarea) return;
    const row = textarea.closest('[data-lvc-gift-options]');
    if (!row || !row.dataset.noteLineKey) return;
    const previous = debounceTimers.get(textarea);
    if (previous) window.clearTimeout(previous);
    debounceTimers.set(textarea, window.setTimeout(() => updateNote(row),700));
  });

  document.addEventListener('click', async (event) => {
    const nav = event.target.closest('[data-lvc-cross-nav]');
    if (nav) {
      event.preventDefault();
      const crossSell = nav.closest('[data-lvc-cart-cross-sell]');
      const track = crossSell?.querySelector('[data-lvc-cross-track]') || drawer()?.querySelector('[data-lvc-cross-track]');
      if (track) {
        const direction = nav.dataset.lvcCrossNav === 'prev' ? -1 : 1;
        const amount = Math.max(track.clientWidth * 0.92, 260);
        track.scrollBy({left: direction * amount, behavior:'smooth'});
      }
      return;
    }
    const add = event.target.closest('[data-lvc-cross-add]');
    if (add) {
      event.preventDefault();
      add.disabled=true;
      try {
        const data=await request(window.routes.cart_add_url+'.js',{items:[{id:Number(add.dataset.variantId),quantity:1}]});
        render(data);
      } catch (error) {
        add.disabled=false;
      }
      return;
    }
    if (event.target.closest('[id*="cart-icon-bubble"]')) {
      window.setTimeout(() => {
        initDeliveryTimer();
        const slot = drawer()?.querySelector('[data-lvc-cart-cross-sell]');
        if (slot?.dataset.loaded === 'true') rotateCrossSellHeadline(slot);
        loadCrossSell();
      },180);
    }
    if (event.target.closest('cart-remove-button, .quantity__button')) {
      window.setTimeout(() => {
        cleanupOrphans();
        initDeliveryTimer();
        loadCrossSell(true);
      },1200);
    }
  },true);

  window.addEventListener('pageshow',() => window.setTimeout(() => {
    cleanupOrphans();
    initDeliveryTimer();
  },250));

  document.addEventListener('DOMContentLoaded',() => window.setTimeout(() => {
    cleanupOrphans();
    observeDrawerEnhancements();
    initDeliveryTimer();
    const preload = () => loadCrossSell();
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(preload, {timeout: 1600});
    } else {
      window.setTimeout(preload, 900);
    }
  },250));
})();